"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.getVotesCount = exports.clearAccount = exports.isAccountEmpty = exports.getParentAccount = exports.isSubAccount = exports.isChildAccount = exports.isTokenAccount = exports.isAccount = exports.findTokenAccountByCurrency = exports.withoutToken = exports.accountWithMandatoryTokens = exports.makeEmptyTokenAccount = exports.isUpToDateAccount = exports.isAccountBalanceUnconfirmed = exports.shortAddressPreview = exports.flattenAccounts = exports.listSubAccounts = exports.findSubAccountById = exports.isAccountBalanceSignificant = exports.areAllOperationsLoaded = exports.getAccountSpendableBalance = exports.getAccountName = exports.getAccountUnit = exports.getAccountCurrency = exports.getMainAccount = void 0;
var bakers_1 = require("../families/tezos/bakers");
var types_1 = require("../families/bitcoin/types");
var helpers_1 = require("@ledgerhq/coin-framework/account/helpers");
exports.getMainAccount = helpers_1.getMainAccount;
exports.getAccountCurrency = helpers_1.getAccountCurrency;
exports.getAccountUnit = helpers_1.getAccountUnit;
exports.getAccountName = helpers_1.getAccountName;
exports.getAccountSpendableBalance = helpers_1.getAccountSpendableBalance;
exports.areAllOperationsLoaded = helpers_1.areAllOperationsLoaded;
exports.isAccountBalanceSignificant = helpers_1.isAccountBalanceSignificant;
exports.findSubAccountById = helpers_1.findSubAccountById;
exports.listSubAccounts = helpers_1.listSubAccounts;
exports.flattenAccounts = helpers_1.flattenAccounts;
exports.shortAddressPreview = helpers_1.shortAddressPreview;
exports.isAccountBalanceUnconfirmed = helpers_1.isAccountBalanceUnconfirmed;
exports.isUpToDateAccount = helpers_1.isUpToDateAccount;
exports.makeEmptyTokenAccount = helpers_1.makeEmptyTokenAccount;
exports.accountWithMandatoryTokens = helpers_1.accountWithMandatoryTokens;
exports.withoutToken = helpers_1.withoutToken;
exports.findTokenAccountByCurrency = helpers_1.findTokenAccountByCurrency;
exports.isAccount = helpers_1.isAccount;
exports.isTokenAccount = helpers_1.isTokenAccount;
exports.isChildAccount = helpers_1.isChildAccount;
exports.isSubAccount = helpers_1.isSubAccount;
exports.getParentAccount = helpers_1.getParentAccount;
var isAccountEmpty = function (a) {
    if (a.type === "Account" && a.currency.family === "tron") {
        var tronAcc = a;
        // FIXME: here we compared a BigNumber to a number, would always return false
        return (tronAcc.tronResources && tronAcc.tronResources.bandwidth.freeLimit.eq(0));
    }
    return (0, helpers_1.isAccountEmpty)(a);
};
exports.isAccountEmpty = isAccountEmpty;
// in future, could be a per currency thing
// clear account to a bare minimal version that can be restored via sync
// will preserve the balance to avoid user panic
function clearAccount(account) {
    return (0, helpers_1.clearAccount)(account, function (account) {
        if (account.currency.family === "tron") {
            var tronAcc = account;
            tronAcc.tronResources = __assign(__assign({}, tronAcc.tronResources), { cacheTransactionInfoById: {} });
        }
        if (account.currency.family === "bitcoin") {
            account.bitcoinResources =
                types_1.initialBitcoinResourcesValue;
        }
    });
}
exports.clearAccount = clearAccount;
var getVotesCount = function (account, parentAccount) {
    var _a, _b;
    var mainAccount = (0, helpers_1.getMainAccount)(account, parentAccount);
    // FIXME find a way to make it per family?
    switch (mainAccount.currency.family) {
        case "tezos":
            return (0, bakers_1.isAccountDelegating)(account) ? 1 : 0;
        case "tron":
            return ((_a = mainAccount === null || mainAccount === void 0 ? void 0 : mainAccount.tronResources) === null || _a === void 0 ? void 0 : _a.votes.length) || 0;
        case "osmosis":
        case "cosmos":
            return (((_b = mainAccount === null || mainAccount === void 0 ? void 0 : mainAccount.cosmosResources) === null || _b === void 0 ? void 0 : _b.delegations.length) || 0);
        default:
            return 0;
    }
};
exports.getVotesCount = getVotesCount;
//# sourceMappingURL=helpers.js.map